/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react';
import { fabric } from 'fabric';
import { ColorContext } from '../context/ColorContext';
import { useToolApparel } from '../context/ToolApparelContext';
import { useParams } from "react-router-dom";
import { colorHexMap } from "../colorlibrarygarments";
import { apiUrl } from '../../config/config';


const Loader = () => (
  <div className="loader">
    <div className="spinner"></div>
  </div>
);

const ProductImageComponentFour = ({setGetValue, canvas,switchBars, setImage, setSelectedPart, activePart, setActivePart, Canvasid, pid, setWorkingArea }) => {
  const { selectedColor, selectedColorName } = useContext(ColorContext);
  const [imageSrc, setImageSrc] = useState(null);
  const [backgroundLayer, setBackgroundLayer] = useState(null);
  const [availableParts, setAvailableParts] = useState([]);
  const [products, setProducts] = useState([]);
  const { data: tshirtData, isLoading: isApparelLoading, error: apparelError, retry: retryApparel } = useToolApparel(Canvasid);
  const [isLoading, setIsLoading] = useState(true); // For handling loading indicator
  const offsetValue = 0.01;

  console.log("switchBars",switchBars);

  const productCanvasID = Canvasid;
console.log("selectedColorName",selectedColorName);
  useEffect(() => {
    if (!isApparelLoading) setIsLoading(false);
  }, [isApparelLoading, apparelError]);

  // Preload images in the background for better performance
  useEffect(() => {
    if (products) {
      products.forEach((part) => {
        const img = new Image();
        img.src = `${apiUrl}${part.ProductImageComponent4?.image}`;
      });
    }
  }, [products]);

  const cacheImage = (url) => {
    if ('caches' in window) {
      return caches.open('image-cache').then((cache) => {
        return cache.match(url).then((response) => {
          if (response) {
            return response.blob();
          }
          return fetch(url).then((fetchedResponse) => {
            cache.put(url, fetchedResponse.clone());
            return fetchedResponse.blob();
          });
        });
      });
    } else {
      return fetch(url).then((response) => response.blob());
    }
  };
  

  const loadImage = async (url) => {
    try {
      const blob = await cacheImage(url);
      const objectURL = URL.createObjectURL(blob);
      return objectURL;
    } catch (error) {
      console.error('Error loading image, falling back to placeholder:', error);
      return '/path/to/placeholder/image.png'; // Fallback to placeholder image
    }
  };
  
  useEffect(() => {
    if (tshirtData) {
      const parts = tshirtData.parts ? JSON.parse(tshirtData.parts) : [];
      const part = parts[3]; // Assuming you want the first part
  
      if (part && part.description) {
        let description = null;
  
        try {
          description = JSON.parse(part.description); // Parse the JSON description
        } catch (error) {
          console.error('Invalid JSON format for description:', error);
          return;
        }
  
        // Validate `switchBars` and fetch the correct design area
        const designAreaKey = switchBars; // Convert to lowercase for consistency
        if (designAreaKey && description[designAreaKey]) {
          const designAreaData = description[designAreaKey]?.DesignAreaComponent4;
          const workingArea = description[designAreaKey]?.workingArea;
  
          if (designAreaData) {
            // Update state with the selected design area
            setWorkingArea(workingArea || null);
            setSelectedPart(designAreaData);
  
            // Handle image setting based on the type
            if (tshirtData.type === "Masking" && part.ProductImageComponent4?.image) {
              const imageUrl = `${apiUrl}${part.ProductImageComponent4.image}`;
              setImageSrc(imageUrl);
            } else if (tshirtData.type === "Images" && part.ProductImageComponent4?.colors) {
              if (selectedColorName) {
                const colorImage = part.ProductImageComponent4.colors[selectedColorName];
                if (colorImage) {
                  const imageUrl = `${apiUrl}${colorImage}`;
                  setImageSrc(imageUrl);
                } else {
                  console.error(`Image not found for color name: ${selectedColorName}`);
                }
              } else {
                console.error('No selected color name provided.');
              }
            }
          } else {
            console.error(`DesignAreaComponent4 not found for ${designAreaKey}`);
          }
        } else {
          console.error(`Design area key not found for ${switchBars}`);
        }
      } else {
        console.error('Invalid part or missing description');
      }
    }
  }, [tshirtData, selectedColorName, switchBars]);
  
  
  
  

  useEffect(() => {
    if (!canvas || !imageSrc) {
      console.log('Canvas not initialized or image not set');
      return;
    }

    const setBackgroundImage = async () => {
      try {
        setIsLoading(true); // Start loading
        const imgUrl = await loadImage(imageSrc);
        console.log("imgurlcheck",imgUrl);
        fabric.Image.fromURL(imgUrl, (img) => {
          if (!img) throw new Error('Image failed to load');
          let bgLayer = backgroundLayer;
          if (!bgLayer) {
            bgLayer = new fabric.Rect({
              fill: selectedColor,

              selectable: false,
              evented: false,
              originX: 'center',
              originY: 'center',
              backgroundLayer: true,
              designElement: false,
            });
            canvas.add(bgLayer);
            setBackgroundLayer(bgLayer);
          } else {
            bgLayer.set({ fill: selectedColor });
          }

          const adjustImageAndLayer = () => {
              if (!canvas || !canvas.getContext || !canvas.contextContainer) return;
  if (!img) return;
            const canvasAspect = canvas.width / canvas.height;
            const imgAspect = img.width / img.height;

            if (imgAspect > canvasAspect) {
              img.scaleToHeight(canvas.height);
            } else {
              img.scaleToWidth(canvas.width);
            }

            img.set({
           
              selectable: false,
              evented: false,
              originX: 'center',
              originY: 'center',
              top: canvas.height / 2,
              left: canvas.width / 2,
              designElement: false,
            });

            const offsetX = img.getScaledWidth() * offsetValue;
            const offsetY = img.getScaledHeight() * offsetValue;

            bgLayer.set({
              width: img.getScaledWidth() - 2 * offsetX,
              height: img.getScaledHeight() - 2 * offsetY,
              top: img.top,
              left: img.left,
              designElement: false,
            });

            if (!canvas.getObjects().includes(img)) {
              canvas.add(img);
            }
            canvas.sendToBack(img);
            canvas.sendToBack(bgLayer);
            canvas.renderAll();
          };

          const productImages = canvas.getObjects().filter(obj => obj.productImage);
          productImages.forEach((obj) => canvas.remove(obj));

          img.set({ productImage: true,
          });
          adjustImageAndLayer();
          setImage(img);

          const adjustImageAndLayerPosition = () => {
            if (!canvas || !img || !bgLayer) {
              console.log('Canvas, image, or background layer is not initialized');
              return;
            }

            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;

            // Define the minimum width the image can have
            const minImageWidth = 700; // Set this to your desired minimum width in pixels

            // Calculate the scale while respecting the minimum width constraint
            const scale = Math.min(
              Math.max(canvasWidth / img.width, minImageWidth / img.width), 
              canvasHeight / img.height
            );

            img.set({

              scaleX: scale,
              scaleY: scale,
              top: canvasHeight / 2,
              left: canvasWidth / 2,
              designElement: false,
            });

            const offsetX = img.getScaledWidth() * offsetValue;
            const offsetY = img.getScaledHeight() * offsetValue;

            bgLayer.set({
              width: img.getScaledWidth() - 2 * offsetX,
              height: img.getScaledHeight() - 2 * offsetY,
              top: img.top,
              left: img.left,
              designElement: false,
            });

            console.log('Adjusted layer and image positions');
            console.log('Layer position:', { top: bgLayer.top, left: bgLayer.left });
            console.log('Layer size:', { width: bgLayer.width, height: bgLayer.height });
            console.log('Layer fill:', bgLayer.fill);

            if (canvas.contextContainer) {
              canvas.renderAll();
            }
          };

          window.addEventListener('resize', adjustImageAndLayerPosition);

          adjustImageAndLayerPosition();

          setIsLoading(false); // End loading
          canvas.fire('product:ready');
         

          return () => {
            window.removeEventListener('resize', adjustImageAndLayerPosition);
             
          };
        });
        
      } catch (error) {
        console.error('Error setting background image:', error);
        setIsLoading(false); // End loading
      }
    };

    setBackgroundImage();
  }, [canvas, setImage, imageSrc, selectedColor]);

  useEffect(() => {
    if (backgroundLayer) {
      backgroundLayer.set({ fill: selectedColor });
      canvas.renderAll();
    }
  }, [selectedColor, backgroundLayer, canvas]);

  const handlePartChange = (part) => {
    setActivePart(part.name);
    setSelectedPart(part);
    setImageSrc(part.ProductImageComponentOne?.image);
  };

  return (
    <div>
      {/* Show loader while loading */}
      <p></p>
      {apparelError ? (
        <div role="alert">
          <p>Unable to load the product. Please try again.</p>
          <button type="button" onClick={retryApparel}>Retry</button>
        </div>
      ) : isLoading || isApparelLoading ? (
        <Loader />
      ) : (
        <div id="canvas-container">
          {/* Canvas will be rendered here */}
        </div>
      )}
    </div>
  );
};

export default ProductImageComponentFour;
